// vue components
import TravelTileItem from './vue/components/_travel-tile-item.vue';

Vue.component('travel-tile-item', TravelTileItem);

let rememberedCodes = Vue.observable({ rememberedCodes: [] })
if(Vue.prototype.$rememberedCodes === undefined)Object.defineProperty(Vue.prototype, '$rememberedCodes', {
    get () {
        return rememberedCodes.rememberedCodes
    },
    set (value) {
        rememberedCodes.rememberedCodes = value
    }
})


if(window.localStorage.getItem('travel-list')){
    Vue.prototype.$rememberedCodes = window.localStorage.getItem('travel-list').split(',');
} else {
    Vue.prototype.$rememberedCodes = [];
}